import React, { FC, ReactNode } from "react";
import styled, { css } from "styled-components";
import { theme } from "../config/theme";
import { Text } from "src/components/text";
import { Counter } from "./tab";

type StyledRadioProps = {
  checked?:  boolean;
  disabled?: boolean;
};
interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked?:  boolean;
  children?: any;
  disabled?: boolean;
  label?:    string;
  name?:     string;
  count?:    ReactNode;
  options?:  any[];
  value?:    any;
  onClick?:  (value?: any) => void;
}

const CheckMark = styled.span`
  position:      absolute;
/*   top:           0; */
  left:          0;
  height:        1.6rem;
  width:         1.6rem;
  border-radius: 50%;
  border:        1px solid ${theme.color.formElements.border};
  transition:    width 2s, height 2s, background-color 2s, transform 2s;
`;

const RadioContainer = styled.div`
  display: flex;
  align-items: center;
`

const RadioInput = styled.input<StyledRadioProps>`
  position: absolute;
  opacity:  0;
  cursor:   pointer;

  &:hover:enabled ~ ${CheckMark} {
    border: 1px solid ${theme.color.formElements.hover};
    transform: scale(1.02);
  }

  &:active:enabled ~ ${CheckMark} {
    border: 1px solid ${theme.color.formElements.active};
  }

  &:focus:enabled  ~ ${CheckMark} {
    outline: 2px solid ${theme.color.formElements.focus};
  }

  &:checked ~ ${CheckMark} {
    border: 1px solid ${theme.color.formElements.radioButtonMain};
    background: radial-gradient(
      #0C668E 0%,
      #0C668E 50%,
      transparent 50%,
      transparent
    );
    transform: scale(1.02);
    display: block;
  }

  ${CheckMark}:after {
    content:  "";
    position: absolute;
    display:  none;
  }
`;

const RadioGroup = styled.label<RadioProps>`
  display:             flex;
  flex-direction:      row;
  align-items:         center;
  position:            relative;
  margin-bottom:       0.2rem;
  cursor:              pointer;
  font-size:           ${theme.font.size.small};
  -webkit-user-select: none;
  -moz-user-select:    none;
  -ms-user-select:     none;
  user-select:         none;
  ${(p) =>
    p.disabled &&
    css`
      color: ${theme.color.disabled};
      cursor: not-allowed;
    `};
`;

const StyledText = styled(Text)`
  margin-left: 2.2rem;
  font-size: ${theme.font.size.small};
`;

export const Radio: FC<RadioProps> = ({
  disabled = false,
  onClick,
  checked,
  value,
  name,
  count,
  options = [],
  ...rest
}) => {
  return (
    <RadioContainer>
      <RadioGroup
        disabled = {!!disabled}
        onClick  = {() => (!disabled && onClick ? onClick(value) : null)}
      >
        <RadioInput
          disabled = {disabled}
          type     = "radio"
          checked  = {checked}
          name     = {name}
          onChange = {() => {}}
          {...rest}
        />
        <StyledText as="p">{value}</StyledText>
        <CheckMark />

        {count &&
        <Counter>{count}</Counter>
        }
      </RadioGroup>
    </RadioContainer>
  );
};
